import { render, staticRenderFns } from "./ColorOptionsItem.vue?vue&type=template&id=0488fd98&scoped=true&"
import script from "./ColorOptionsItem.vue?vue&type=script&lang=js&"
export * from "./ColorOptionsItem.vue?vue&type=script&lang=js&"
import style0 from "./ColorOptionsItem.vue?vue&type=style&index=0&id=0488fd98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0488fd98",
  null
  
)

export default component.exports